import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["error", "children", "errorAriaLabel", "theme"];
import React from 'react';
import { deprecatedPropWarning } from "../../deprecationWarnings";
import { Help } from "./Help";
import { IconExclamationAltActiveForText } from "./IconExclamationAltActiveForText";
import { Text } from "./Text";
export var FormHelpText = function FormHelpText(_ref) {
  var error = _ref.error,
      children = _ref.children,
      _ref$errorAriaLabel = _ref.errorAriaLabel,
      errorAriaLabel = _ref$errorAriaLabel === void 0 ? 'Error:' : _ref$errorAriaLabel,
      theme = _ref.theme,
      props = _objectWithoutProperties(_ref, _excluded);

  if (theme) {
    deprecatedPropWarning('theme', 'This component is intended to inherit its parent’s color set or color.');
  }

  return /*#__PURE__*/React.createElement(Help, Object.assign({
    error: error
  }, props), error && /*#__PURE__*/React.createElement(IconExclamationAltActiveForText, {
    "aria-label": errorAriaLabel
  }), /*#__PURE__*/React.createElement(Text, null, children));
};
/**
* **FormHelpText** ![Status: Production](https://img.shields.io/badge/PRODUCTION-%2357B560|height=14)
*
* [GitHub](https://ghe.spotify.net/encore/web/tree/master/src/core/components/FormHelpText) | [Storybook](https://encore-web.spotify.net/?path=/docs/components-form-formhelptext--default) | [Encore](https://encore.spotify.net/web/components/form?format=figma-figma#formhelptext) | [Figma](https://www.figma.com/file/bnQXqGkLeiTlbk8JXGDcsX/Encore-Web---Light-Theme-Toolkit?node-id=0:866) |
*
* FormHelpText is placed after a form field and can display contextual information, character count or error notifications.
*
* @example
* () => <FormHelpText>Helpful information</FormHelpText>;
*
*/

export default FormHelpText;